<div class="container-fluid">
    <p>Sikeres bejelentkezés...</p>
</div>